var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.94043,
    y: 0.530273,
    width: 57.311,
    height: 57.5405,
    rx: 7.5,
    fill: "#FF6B00",
    fillOpacity: 0.1,
    stroke: "#FF6B00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.112 19.73V21.644M18.112 38.87V29.3",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.682 29.3001C27.682 26.1288 30.2527 23.5581 33.424 23.5581C36.5953 23.5581 39.166 26.1288 39.166 29.3001C39.166 32.4714 36.5953 35.0421 33.424 35.0421C30.2527 35.0421 27.682 32.4714 27.682 29.3001Z",
    stroke: "#FF6B00",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.553 24.3263C31.3977 23.8377 32.3782 23.5581 33.424 23.5581C36.5953 23.5581 39.166 26.1288 39.166 29.3001C39.166 32.4714 36.5953 35.0421 33.424 35.0421C30.2527 35.0421 27.682 32.4714 27.682 29.3001C27.682 28.2543 27.9616 27.2738 28.4501 26.4291",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.209 24.515L41.08 21.644",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.768 36.956L28.639 34.085",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.639 24.515L25.768 21.644",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.08 36.956L38.209 34.085",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.736 29.3002C48.736 38.3228 48.736 42.8342 45.9329 45.6371C43.1301 48.4402 38.6186 48.4402 29.596 48.4402C20.5733 48.4402 16.062 48.4402 13.259 45.6371C10.456 42.8342 10.456 38.3228 10.456 29.3002C10.456 20.2775 10.456 15.7661 13.259 12.9632C16.062 10.1602 20.5733 10.1602 29.596 10.1602C38.6186 10.1602 43.1301 10.1602 45.9329 12.9632C47.7968 14.8269 48.4213 17.4459 48.6305 21.6442",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/iq.ec64ab0727ac0c88c112f4b4c63c3c4e.svg";
export { ForwardRef as ReactComponent };